import { render, staticRenderFns } from "./actionDetails.vue?vue&type=template&id=108bff20"
import script from "./actionDetails.vue?vue&type=script&lang=js"
export * from "./actionDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports